import { SpendTracker } from '../models/skyclub.interfaces';

export const remainSpend: SpendTracker = {
  total: {
    title: '$63k',
    subtitle: 'Total Spend in 2025'
  },
  max: '$75k',
  tooltip: {
    title: '$12k to Unlimited Delta Sky Club Access',
    subtitle:
      '<p>American Express spend toward Unlimited Delta Sky Club is tracked from January 1st through December 31st. You must spend $75k to reach Unlimited Sky Club access. Access begins immediately once $75k is spent, and is valid through the end of the following Medallion year. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>'
  }
};

export const noneSpent: SpendTracker = {
  total: {
    title: '$0',
    subtitle: 'Total Spend in 2025'
  },
  max: '$75k',
  tooltip: {
    title: '$75k to Unlimited Delta Sky Club Access',
    subtitle:
      '<p>American Express spend toward Unlimited Delta Sky Club is tracked from January 1st through December 31st. You must spend $75k to reach Unlimited Sky Club access. Access begins immediately once $75k is spent, and is valid through the end of the following Medallion year. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>'
  }
};

export const metThreshold: SpendTracker = {
  total: {
    title: '$75k',
    subtitle: 'Total Spend in 2025'
  },
  max: '$75k',
  tooltip: {
    title: '$0 to Unlimited Delta Sky Club Access',
    subtitle:
      '<p>American Express spend toward Unlimited Delta Sky Club is tracked from January 1st through December 31st. You must spend $75k to reach Unlimited Sky Club access. Access begins immediately once $75k is spent, and is valid through the end of the following Medallion year. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>'
  }
};
